<template>
  <nav class="header navbar-expand-lg ">
    <div class="header-container">
        <div class="">
            <a class="navbar-brand" href=""><img :src="urlWeb + '/assets/images/logos/ITSAPP_ FullColor_1280x1024.png'" alt="Main Logo"></a>
        </div>
        <div class="navbar-collapse"
            id="navbarSupportedContent">
            <ul
                class="navbar-nav me-auto mb-2 mb-lg-0 w-100  align-items-center">
                <li class="nav-item">
                    <router-link to="/" :class="{ 'active': type === 'home','nav-link':true }">Home</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/Nosotros" :class="{ 'active': type === 'nosotros','nav-link':true }">Nosotros</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/Empresas" :class="{ 'active': type === 'empresas','nav-link':true }">Empresas</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/Consultores" :class="{ 'active': type === 'consultores','nav-link':true }">Consultores</router-link>
                </li>
                <li class="nav-item">
                  <router-link to="/Planes" :class="{ 'active': type === 'planes','nav-link':true }">Planes y Costos</router-link>
                </li>
                <li class="nav-item m-2">
                    <router-link to="/registro" class="nav-link nav-link-btn">Registrarse</router-link>
                </li>
                <li class="nav-item m-2">
                    <router-link to="/Login" class="nav-link nav-link-btn" >Entrar</router-link>
                </li>
            </ul>
        </div>
    </div>
  </nav>
</template>
  
  <script>
  import { mapState } from 'vuex'
  export default {
    computed:{
      ...mapState(['urlWeb']),
    },
  props:['type'],
    name: 'Header',
    data () {
      return {
      }
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/Header.vue